/* eslint-disable react/prop-types */
import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = 'euro',
  viewBox = '0 0 415.882 415.882',
  enableBackground = 'new 0 0 415.882 415.882',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    enableBackground={enableBackground}
  >
    <path
      fill={fill}
      d="m297.058 386.176c-77.429 0-143.291-49.71-167.837-118.823h167.837v-29.706h-175.551c-1.635-9.684-2.683-19.565-2.683-29.706s1.048-20.022 2.683-29.706h175.552v-29.706h-167.838c24.546-69.113 90.409-118.823 167.837-118.823 26.515 0 52.246 5.845 76.484 17.391l12.634-26.834c-28.256-13.446-58.15-20.263-89.118-20.263-94.009 0-173.546 62.746-199.183 148.529h-68.169v29.706h61.783c-1.402 9.729-2.372 19.594-2.372 29.706s.97 19.977 2.372 29.706h-61.783v29.706h68.169c25.637 85.783 105.174 148.529 199.184 148.529 30.997 0 60.891-6.817 89.117-20.278l-12.648-26.805c-24.194 11.531-49.926 17.377-76.47 17.377z"
    />
  </svg>
);

export default SVG;
